import { useState } from 'react'
import { Icon } from '@iconify/react'
import { patch } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import Modal from '../../../../components/modal/Modal'
import FormLoader from '../../../../components/loader/FormLoader'
import '../customers/CustomerModals.scss'

interface Props {
  identityId: string
  currentName: string
  onClose: () => void
  onSuccess: () => void
}

// Used when a business's re-upload is refused with ID_NAME_MISMATCH and they
// contact support. Creates a new version (same image, new name); earlier
// versions and the bookings made with them are untouched.
const CorrectNameModal = ({ identityId, currentName, onClose, onSuccess }: Props) => {
  const { notify } = useGlobalContext()
  const [fullName, setFullName] = useState(currentName)
  const [reason, setReason] = useState('')
  const [loading, setLoading] = useState(false)

  const canSave =
    fullName.trim().length >= 2 &&
    fullName.trim() !== currentName &&
    reason.trim().length >= 5

  const save = () => {
    setLoading(true)
    patch(`admin/customer-identities/${identityId}/name`, {
      fullName: fullName.trim(),
      reason: reason.trim(),
    })
      .then((res: any) => {
        if (res.success) {
          notify('success', 'Name corrected')
          onClose()
          onSuccess()
        } else notify('error', res.message)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-green'>
            <Icon icon='mdi:account-edit-outline' />
          </div>
          <h2>Correct Name</h2>
          <p>
            Saved as a new version with the same ID image. Earlier versions, and
            the bookings made with them, keep the old name.
          </p>
        </div>

        <div className='form-group'>
          <label>Full name, as on the ID</label>
          <input
            type='text'
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            autoFocus
          />
        </div>
        <div className='form-group'>
          <label>Reason</label>
          <textarea
            rows={3}
            placeholder='e.g. Business reported a typo — confirmed against the ID image'
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button className='btn-proceed' onClick={save} disabled={!canSave}>
              Save correction
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CorrectNameModal
